<!--
 * @Author: zxf
 * @Date: 2022-07-26 22:24:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:27:07
 * @Description: 文件数据上传
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-30 o-dialog--xl-50"
    title="选择文件类型"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="110px"
        label-suffix="："
      >
        <el-row class="c-form__row">
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="项目名称"
              prop="xmmc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.xmmc }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="报告编号"
              prop="bgbh"
            >
              <span
                class="c-form__read"
              >
                {{ fd.bgbh }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="文件类型"
              prop="type"
            >
              <el-radio-group
                v-model="fd.type"
                class="c-form__radio-group"
              >
                <el-radio label="1">
                  扫描件
                </el-radio>
                <el-radio label="3">
                  电子文档
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="上传文件"
              prop="fileId"
            >
              <file-serve-upload
                ref="smjFileUpload"
                v-model="fd.fileId"
                class="u-inline-block"
                :file-api="$config.ctx.hmfileApi"
                show-file-list
                accept="application/pdf,application/msword,.doc,.docx"
                :data="uploadFd"
                :max-size="30 * 1024"
              >
                <k-button
                  btn-text="选择文件"
                  :auth-type="true"
                  type="primary"
                  icon="kestrel-icon ki-cloud-upload"
                  plain
                />
              </file-serve-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      class="o-tips u-mg-t-10"
    >
      <div class="o-tips__title">
        {{ dlParams.id ? '说明：' : '温馨提示：' }}
      </div>
      <ul
        v-if="dlParams.id"
        class="o-tips__body"
      >
        <li class="o-tips__item">
          1、计划维保内容如需更改请在维保项目管理更改客户的维保内容；
        </li>
        <li class="o-tips__item">
          2、生成报告后如需修改请用主账号开启重新修改功能。
        </li>
      </ul>
      <ul
        v-else
        class="o-tips__body"
      >
        <li class="o-tips__item">
          1、上传的报告需必须盖有公章、工程师签章；
        </li>
        <li class="o-tips__item">
          2、上传报告后，推送的报告是上传后的报告文件；
        </li>
        <li class="o-tips__item">
          3、广东平台推送成功后，将无法撤回、修改或删除报告文件。
        </li>
      </ul>
    </div>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { jcsjtsService } from './jcsjts.service';
export default {
  name: 'JcImportDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading计划年份
      dialogShow: true, // 模态框dialog显示

      /* 表单参数 Start */
      fd: {
        xmId: null, // 项目ID
        xmmc: null, // 项目名称
        wtdw: null, // 委托单位
        bgbh: null, // 报告编号
        fileId: null, // 文件ID
        type: '1' // 类型
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        type: [
          this.$validUtils.required('文件类型')
        ],
        fileId: [
          this.$validUtils.required('文件')
        ]
      },
      /* 表单校验规则 End */
      /* 文件服务器对接参数 Start */
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'wbht',
            value: null
          }
        ]
      }
      /* 文件服务器对接参数 END */

    };
  },
  computed: {
  },
  methods: {
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          jcsjtsService.importBg(_this.fd)
            .then(rsp => {
              this.$alert('上传成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              this.$emit('closeDialog', '');
              this.$emit('callback');
            })
            .catch(err => {
              console.error('上传出错！', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.fd.xmId = this.dlParams.xmId;
    this.fd.xmmc = this.dlParams.xmmc;
    this.fd.bgbh = this.dlParams.bgbh;
  }
};
</script>
